'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './document-tree-upload.routes';

export class DocumentTreeUploadComponent {
  /*@ngInject*/
  constructor(Upload, Auth, DocumentService, $state, $stateParams, Config) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Upload = Upload;
    this.Auth = Auth;
    this.DocumentService = DocumentService;
    this.type = $stateParams.type;

    this.allowedMimeTypes = Config.getPlatformConfig().getAllowedContentTypesForUpload().join(',');

    var documentConfig = Config.getModuleConfig(Config.Modules.Document);

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Document Upload");

    this.permissionModel = {};
    this.roles = Config.getPlatformConfig().getPermissionRoles();
    this.defaultUploadUserPermission = Config.getPlatformConfig().getDefaultPermissionUserUpload();
    this.roles.forEach(role => {
      this.permissionModel[role] = this.defaultUploadUserPermission.includes(role);
    });

    this.documentTree = documentConfig.getDocumentTree();

    // Enumeration with possible document types
    this.documentType = documentConfig.getTypes();
    this.documentPageCategories = documentConfig.getPageCategories();

    this.documentType = [];
    this.docTypesEnum = [];

    this.addPath = _ => {
      this.document.tree.push({
        path: "",
        orderNumber: 100
      });
    };

    let rFn = (node, o, parent) => {

      let _parentId = (parent) ? parent.value + "::" : "";
      let _parentName = (parent) ? parent.name + " → " : "";

      let newNode = {
        value: _parentId + node.id,
        name: _parentName + node.name,
        group: "General"
      };

      o.push(newNode);

      if (node.children && node.children.length) {
        node.children.forEach(child => rFn(child, o, newNode))
      }
    };

    this.documentTree.forEach(node => rFn(node, this.docTypesEnum));

    this.documentTemplate = {
      tree: [{
        path: '',
        orderNumber: 100
      }],
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    this.document = angular.copy(this.documentTemplate);
    this.submitted = false;
  }

  removeCat(idx) {
    this.document.tree.splice(idx,1);
  }

  upload(form) {

    this.submitted = true;
    this.sendSuccess = false;
    this.sendFailure = false;

    if (form.$valid) {

      let permission = [];

      if (!this.document.isPublic) {
        for (let role in this.permissionModel) {
          if (this.permissionModel.hasOwnProperty(role)) {
            if (this.permissionModel[role] === true){
              permission.push(role);
            }
          }
        }
      }

      this.Upload.upload({
        url: '/api/storage',
        data: {
          name: this.documentFile.name,
          file: this.documentFile,
          storageStrategy: 'local',
          permission: permission.join(','),
          isPublic: this.document.isPublic,
          creationUser: this.Auth.getCurrentUserSync()._id,
          active: true
        }
      }).then(
        (res) => {

          this.document.document = res.data;

          this.DocumentService.save(this.document, () => {
              this.document = angular.copy(this.documentTemplate);
              delete this.documentFile;
              this.submitted = false;
              this.sendSuccess = true;
            },
            (err) => {
              this.sendFailure = true;
            })

        },
        (err) => {
          this.sendFailure = true;
        });

    }

  }

}

export default angular.module('conduuApp.documentTreeUpload', [uiRouter])
  .config(routes)
  .component('documentTreeUpload', {
    template: require('./document-tree-upload.html'),
    controller: DocumentTreeUploadComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/document/tree-upload/document-tree-upload.component.js